import { mergeNamespacedMessages } from '../utils';

const context = require.context('./', true, /.namespace.js$/);
const namespacedMessages = mergeNamespacedMessages(context)(context.keys());

export default namespacedMessages;
